// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { invoiceDetailSchema } from '@/billing/api/types';
import { Currency } from '@/currency/api/types';
import { serializeCurrencyForAPI } from '@/currency/utilities/serialize';
import { serializeDateForAPI } from '@/utilities/date-time';
import { DateTime } from 'luxon';
import { z } from 'zod';

const recordPaymentResponseSchema = z.object({
  data: invoiceDetailSchema,
  metadata: responseMetadataSchema,
});

export interface RecordPaymentInput {
  invoiceKey: string;
  amount: Currency;
  paymentDate: DateTime;
  customerKey: string | null;
  reference: string | null;
  memo: string | null;
}

export async function recordPayment(input: RecordPaymentInput) {
  const url = `/v1/invoice/${input.invoiceKey}/record-payment`;
  const response = await api.post(url, {
    amount: serializeCurrencyForAPI(input.amount),
    paymentDate: serializeDateForAPI(input.paymentDate),
    customerKey: input.customerKey,
    reference: input.reference,
    memo: input.memo,
  });

  const result = await parseResponse(
    recordPaymentResponseSchema,
    response.data,
    {
      schemaName: 'RecordPayment',
      endpoint: url,
    }
  );
  return result.data;
}
